export interface TextStats {
  characters: number;
  words: number;
  lines: number;
  /** Rough page estimate (~1800 chars/page). */
  pages: number;
  /** Estimated reading time in minutes (~200 wpm), min 1 when non-empty. */
  readingMinutes: number;
}

const WORDS_PER_MINUTE = 200;
const CHARS_PER_PAGE = 1800;

/** Compute display statistics for a block of extracted text/markdown. */
export const computeTextStats = (content: string): TextStats => {
  const trimmed = content.trim();
  const words = trimmed ? trimmed.split(/\s+/).filter(Boolean).length : 0;
  const characters = content.length;
  const lines = content ? content.split(/\r?\n/).length : 0;
  const pages = characters ? Math.max(1, Math.ceil(characters / CHARS_PER_PAGE)) : 0;
  const readingMinutes = words ? Math.max(1, Math.round(words / WORDS_PER_MINUTE)) : 0;

  return { characters, words, lines, pages, readingMinutes };
};

/** Count case-insensitive occurrences of `query` within `content`. */
export const countMatches = (content: string, query: string): number => {
  if (!query) return 0;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const matches = content.match(new RegExp(escaped, 'gi'));
  return matches ? matches.length : 0;
};
